import { VOD_DATA_HYDRATED } from '@wix/wix-vod-constants/dist/env/events';

class HydratedData {
  static HYDRATED_DATA_KEYS = {
    EXPERIMENTS: '__EXPERIMENTS__',
    STYLE_PARAMS: '__STYLE_PARAMS__',
    CHANNEL: '__CHANNEL__',
    CHANNEL_VIDEOS: '__VIDEOS__',
    MEMBER_INFO: '__MEMBER_INFO__',
    SINGLE_VIDEO: '__SINGLE_VIDEO__',
    TRANSLATIONS: '__TRANSLATIONS__',
    CURRENT_SITE_USER: '__CURRENT_SITE_USER__',
  };

  constructor(context) {
    this.context = context;
  }

  _getExperiments = () =>
    this.context[HydratedData.HYDRATED_DATA_KEYS.EXPERIMENTS];
  _getStyleParams = () =>
    this.context[HydratedData.HYDRATED_DATA_KEYS.STYLE_PARAMS];
  _getChannel = () => this.context[HydratedData.HYDRATED_DATA_KEYS.CHANNEL];
  _getChannelVideos = () =>
    this.context[HydratedData.HYDRATED_DATA_KEYS.CHANNEL_VIDEOS];
  _getMemberInfo = () =>
    this.context[HydratedData.HYDRATED_DATA_KEYS.MEMBER_INFO];
  _getSingleVideo = () =>
    this.context[HydratedData.HYDRATED_DATA_KEYS.SINGLE_VIDEO];
  _getTranslations = () =>
    this.context[HydratedData.HYDRATED_DATA_KEYS.TRANSLATIONS];
  _getCurrentSiteUser = () =>
    this.context[HydratedData.HYDRATED_DATA_KEYS.CURRENT_SITE_USER];

  _wrapResponseData = data => (data ? { data } : null);

  getExperiments = () => this._getExperiments();
  getStyleParams = () => this._getStyleParams();
  getTranslations = () => this._getTranslations();
  getCurrentSiteUser = () => this._getCurrentSiteUser();
  getSingleVideoId = () => _.get(this._getSingleVideo(), 'base_item_id');

  getChannelResponse = () => this._wrapResponseData(this._getChannel());
  getChannelVideosResponse = () =>
    this._wrapResponseData(this._getChannelVideos());
  getMemberInfoResponse = () => this._wrapResponseData(this._getMemberInfo());
  getSingleVideoResponse = () => this._wrapResponseData(this._getSingleVideo());

  getLocale = () => _.get(this.getStyleParams(), 'fonts.language');

  cleanup = () => {
    delete this.context[HydratedData.HYDRATED_DATA_KEYS.CHANNEL_VIDEOS];
    delete this.context[HydratedData.HYDRATED_DATA_KEYS.MEMBER_INFO];
    delete this.context[HydratedData.HYDRATED_DATA_KEYS.SINGLE_VIDEO];
  };

  onReady = listener => {
    window.addEventListener(VOD_DATA_HYDRATED, listener);
  };
}

export const hydratedData = new HydratedData(window);
